import { useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { Button, Col, DatePicker, Form, Row, Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const DashboardFilters = ({
  clients = [],
  agents = [],
  tls = [],
  departments = [],
  auditForms = [],
  auditors = [],
  isValid = true,
  onFilterChange,
  onSubmit,
}) => {
  const { RangePicker } = DatePicker;
  const currentMonth = dayjs();

  const [openSelect, setOpenSelect] = useState({});

  const DropdownArrow = ({ field }) => (
    <DownOutlined
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.stopPropagation();
        setOpenSelect((prev) => ({
          ...prev,
          [field]: !prev[field],
        }));
      }}
    />
  );

  const slsRole = secureLocalStorage.getItem("role");

  return (
    <div className="filters-container-gn mt-0">
      <Form onFinish={onSubmit}>
        <Row gutter={[12, 12]}>
          {/*Month*/}
          <Col xs={24} sm={12} md={9} lg={8} xl={5} xxl={4}>
            <Form.Item name="month" className="m-0">
              <RangePicker
                picker="month"
                format="MMMM YYYY"
                defaultValue={[currentMonth, currentMonth]}
                onChange={(val) => onFilterChange("month", val)}
                allowClear
              />
            </Form.Item>
          </Col>

          {/*Audited By*/}
          {/* {slsRole !== process.env.REACT_APP_ATLROLE && ( */}
          <Col xs={24} sm={12} md={5} lg={4} xl={3} xxl={3}>
            <Form.Item name="auditedBy" className="m-0">
              <Select
                showSearch
                allowClear
                className="dsh-filter-style"
                placeholder="Audited By"
                options={[
                  {
                    label: "Auditors",
                    value: "auditors",
                  },
                  {
                    label: "Ops",
                    value: "ops",
                  },
                ]}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(val) => onFilterChange("auditedBy", val)}
              />
            </Form.Item>
          </Col>
          {/* )} */}

          {/*Clients*/}
          <Col xs={12} sm={8} md={5} lg={4} xl={2} xxl={2}>
            <Form.Item name="clients" className="m-0">
              <Select
                mode="multiple"
                showSearch
                allowClear
                className="dsh-filter-style"
                placeholder="Client"
                options={clients}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(val) => onFilterChange("clients", val)}
              />
              {/* <Select
                mode="multiple"
                showSearch
                allowClear
                showArrow
                open={openSelect.clients}
                onDropdownVisibleChange={(val) =>
                  setOpenSelect((prev) => ({ ...prev, clients: val }))
                }
                suffixIcon={<DropdownArrow field="clients" />}
                className="dsh-filter-style"
                placeholder="Client"
                options={clients}
                onChange={(val) => onFilterChange("clients", val)}
              /> */}
            </Form.Item>
          </Col>

          {/*Agents w.r.t. Client*/}
          {(slsRole === process.env.REACT_APP_TLROLE ||
            slsRole === process.env.REACT_APP_ATLROLE ||
            slsRole === process.env.REACT_APP_AUDROLE ||
            slsRole === process.env.REACT_APP_QC) && (
            <Col xs={12} sm={8} md={5} lg={4} xl={2} xxl={2}>
              <Form.Item name="agents" className="m-0">
                <Select
                  showSearch
                  allowClear
                  mode={"multiple"}
                  showArrow
                  // open={openSelect.agents}
                  // onDropdownVisibleChange={(val) =>
                  //   setOpenSelect((prev) => ({ ...prev, agents: val }))
                  // }
                  // suffixIcon={<DropdownArrow field="agents" />}
                  isclearable="true"
                  className="dsh-filter-style"
                  placeholder="Agent"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                  options={agents}
                  onChange={(val) => onFilterChange("agents", val)}
                ></Select>
              </Form.Item>
            </Col>
          )}

          {/*Tls w.r.t. Agent*/}
          {slsRole !== process.env.REACT_APP_TLROLE &&
            slsRole !== process.env.REACT_APP_ATLROLE &&
            slsRole !== process.env.REACT_APP_AGROLE && (
              <Col xs={12} sm={8} md={5} lg={4} xl={2} xxl={2}>
                <Form.Item name="tls" className="m-0">
                  {/* <Select
                    showSearch
                    allowClear
                    mode={"multiple"}
                    isclearable="true"
                    className="dsh-filter-style"
                    placeholder="Select TL"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        ?.toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                    options={tls}
                    onChange={(val, option) => {
                      setAtls([]);
                      if (val) {
                        handleTlAtls(val);
                      }
                    }}
                  ></Select> */}

                  <Select
                    showSearch
                    allowClear
                    mode={"multiple"}
                    showArrow
                    // open={openSelect.tls}
                    // onDropdownVisibleChange={(val) =>
                    //   setOpenSelect((prev) => ({ ...prev, tls: val }))
                    // }
                    //suffixIcon={<DropdownArrow field="tls" />}
                    isclearable="true"
                    className="dsh-filter-style"
                    placeholder="TL"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        ?.toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                    options={tls}
                    onChange={(val) => onFilterChange("tls", val)}
                  ></Select>
                </Form.Item>
              </Col>
            )}

          {/*Atls w.r.t. Tl*/}
          {/* {slsRole==='admin' &&
                    <Col span={slsRole==='admin'?3:3}>
                      <Form.Item name="atl" className="m-0">
                        <Select
                          showSearch
                          allowClear
                          className="dsh-filter-style"
                          placeholder="Select ATL"
                          
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }
                          options = {atls}
                          onChange={(val, option) => {
                            setAtls([]);
                            
                          }}
                        >                          
                        </Select>
                      </Form.Item>
                    </Col>}                   */}

          {/*Department*/}
          <Col xs={12} sm={8} md={5} lg={4} xl={3} xxl={3}>
            <Form.Item name="departments" className="m-0">
              <Select
                showSearch
                allowClear
                mode={"multiple"}
                showArrow
                // open={openSelect.departments}
                // onDropdownVisibleChange={(val) =>
                //   setOpenSelect((prev) => ({ ...prev, departments: val }))
                // }
                //suffixIcon={<DropdownArrow field="departments" />}
                isclearable="true"
                className="dsh-filter-style"
                placeholder="Department"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    ?.toLowerCase()
                    .includes(input?.toLowerCase())
                }
                options={departments}
                onChange={(val) => onFilterChange("departments", val)}
              ></Select>
            </Form.Item>
          </Col>

          {/*AuditForm w.r.t Department's process*/}
          <Col xs={12} sm={8} md={5} lg={4} xl={3} xxl={3}>
            <Form.Item name="auditForms" className="m-0">
              <Select
                showSearch
                allowClear
                mode={"multiple"}
                showArrow
                // open={openSelect.auditForms}
                // onDropdownVisibleChange={(val) =>
                //   setOpenSelect((prev) => ({ ...prev, auditForms: val }))
                // }
                // suffixIcon={<DropdownArrow field="auditForms" />}
                isclearable="true"
                className="dsh-filter-style"
                placeholder="AuditForm"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    ?.toLowerCase()
                    .includes(input?.toLowerCase())
                }
                options={auditForms}
                //onChange={(val) => onFilterChange("tls", val)}
              ></Select>
            </Form.Item>
          </Col>

          {/*Qcs*/}
          {/* {slsRole==='admin' && <Col span={slsRole==='admin'?3:3}>
                      <Form.Item name="qc" className="m-0">
                        <Select
                          showSearch
                          allowClear
                          className="dsh-filter-style"
                          placeholder="Select Qc"
                          
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }

                          options={qcs}
                        >                          
                        </Select>
                      </Form.Item>
                    </Col>} */}

          {/*Auditors*/}
          {(slsRole === process.env.REACT_APP_AROLE ||
            slsRole === process.env.REACT_APP_QC ||
            slsRole === process.env.REACT_APP_AGROLE) && (
            <Col
              xs={12}
              sm={8}
              md={slsRole === process.env.REACT_APP_QC ? 5 : 5}
              lg={slsRole === process.env.REACT_APP_QC ? 4 : 4}
              xl={slsRole === process.env.REACT_APP_QC ? 2 : 3}
              xxl={slsRole === process.env.REACT_APP_QC ? 3 : 3}
            >
              <Form.Item name="auditors" className="m-0">
                <Select
                  showSearch
                  allowClear
                  mode={"multiple"}
                  showArrow
                  // open={openSelect.auditors}
                  // onDropdownVisibleChange={(val) =>
                  //   setOpenSelect((prev) => ({ ...prev, auditors: val }))
                  // }
                  // suffixIcon={<DropdownArrow field="auditors" />}
                  isclearable="true"
                  className="dsh-filter-style"
                  placeholder="Auditor"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                  options={auditors}
                  onChange={(val) => onFilterChange("auditors", val)}
                ></Select>
              </Form.Item>
            </Col>
          )}
          {isValid && (
            <Col
              style={{ marginLeft: "auto" }}
              xs={24}
              sm={24}
              md={
                slsRole === process.env.REACT_APP_AROLE ||
                slsRole === process.env.REACT_APP_AUDROLE
                  ? 3
                  : slsRole === process.env.REACT_APP_QC
                    ? 2
                    : slsRole === process.env.REACT_APP_TLROLE ||
                        slsRole === process.env.REACT_APP_ATLROLE ||
                        slsRole === process.env.REACT_APP_AGROLE ||
                        slsRole === process.env.REACT_APP_MGRROLE
                      ? 3
                      : slsRole === process.env.REACT_APP_AUDROLE
                        ? 3
                        : 3
              }
              xxl={
                slsRole === process.env.REACT_APP_AROLE ||
                slsRole === process.env.REACT_APP_AUDROLE
                  ? 3
                  : slsRole === process.env.REACT_APP_QC
                    ? 2
                    : slsRole === process.env.REACT_APP_TLROLE ||
                        slsRole === process.env.REACT_APP_ATLROLE ||
                        slsRole === process.env.REACT_APP_AGROLE ||
                        slsRole === process.env.REACT_APP_MGRROLE
                      ? 3
                      : slsRole === process.env.REACT_APP_AUDROLE
                        ? 3
                        : 3
              }
            >
              {/*Admin - 4*/}
              <Form.Item className="mb-0 alignRight">
                <Button htmlType="submit" className="defaultBtn">
                  Submit
                </Button>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default DashboardFilters;
